import config from "@/config"
import http from "@/utils/request"

export default {
	list: {
		url: `${config.API_URL}/bwmall/admin/article/list/edit`,
		name: "获取用户协议",
		get: async function(data={}){
			return await http.get(this.url, data);
		},
		//保存（query需带?id=数字id或label，body为全量字段，后端7字段必填）
		post: async function(query, data={}){
			return await http.post(this.url + query, data);
		}
	},
	category: {
		index: {
			url: `${config.API_URL}/bwmall/admin/article/category/index`,
			name: "文章分类列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		add: {
			url: `${config.API_URL}/bwmall/admin/article/category/add`,
			name: "添加文章分类",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		edit: {
			url: `${config.API_URL}/bwmall/admin/article/category/edit`,
			name: "编辑文章分类",
			get: async function(params){
				return await http.get(this.url, params);
			},
			post: async function(params){
				return await http.post(this.url + '?id=' + params.id, params);
			}
		},
		modify: {
			url: `${config.API_URL}/bwmall/admin/article/category/modify`,
			name: "快速修改文章分类字段",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		del: {
			url: `${config.API_URL}/bwmall/admin/article/category/del`,
			name: "删除文章分类",
			post: async function(params){
				return await http.post(this.url, params);
			}
		}
	},
	manage: {
		index: {
			url: `${config.API_URL}/bwmall/admin/article/list/index`,
			name: "文章列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		add: {
			url: `${config.API_URL}/bwmall/admin/article/list/add`,
			name: "添加文章",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		edit: {
			url: `${config.API_URL}/bwmall/admin/article/list/edit`,
			name: "编辑文章",
			get: async function(params){
				return await http.get(this.url, params);
			},
			post: async function(params){
				return await http.post(this.url + '?id=' + params.id, params);
			}
		},
		modify: {
			url: `${config.API_URL}/bwmall/admin/article/list/modify`,
			name: "快速修改文章字段",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		del: {
			url: `${config.API_URL}/bwmall/admin/article/list/del`,
			name: "删除文章",
			post: async function(params){
				return await http.post(this.url, params);
			}
		}
	}
}
